import { render, staticRenderFns } from "./relectureDetailsUser.vue?vue&type=template&id=ddc2318e"
import script from "./relectureDetailsUser.vue?vue&type=script&lang=js"
export * from "./relectureDetailsUser.vue?vue&type=script&lang=js"
import style0 from "./relectureDetailsUser.vue?vue&type=style&index=0&id=ddc2318e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports